
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/global-freight-summit-2023",
      function () {
        return require("private-next-pages/events/global-freight-summit-2023/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/global-freight-summit-2023"])
      });
    }
  